import { RSAA } from '@flowio/redux-async-middleware';
import { operationTypes } from '@flowio/redux-resource';
import PropTypes from 'prop-types';

import { api } from '../../../../utilities/clients';
import { createResourceTypeDescriptors } from '../../helpers';
import { withAssertPropTypes } from '../../../../utilities/prop-types';

export default withAssertPropTypes({
  key: PropTypes.string.isRequired,
  organizationId: PropTypes.string.isRequired,
})(({ key, organizationId }) => ({
  [RSAA]: {
    types: createResourceTypeDescriptors({
      operationType: operationTypes.DELETE,
      resourceType: 'priceBooks',
    }),
    callAPI: (state) => api.priceBooks(state).deleteByKey(organizationId, key),
  },
}));
